// extracted by mini-css-extract-plugin
export default {"Weather_forecast_container":"ForecastWeather_Weather_forecast_container__DvQfk"};